/**
 * Created by Administrador on 17/11/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('ssrService', ssrService)

    ssrService.$inject = ['$http', 'CONFIG', 'messageService'];

    function ssrService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/ssrs';
        var service = {
            getSsrs: getSsrs,
            getSsr: getSsr,
            saveSsr: saveSsr,
            updateSsr: updateSsr,
            deleteItem: deleteItem
        }

        return service;

        function getSsrs(page, size){
            return $http.get(urlBase + '?page=' + page + '&size=' + size + '&detailed=true')
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getSsr(id, detailed){
            return $http.get(urlBase + "/" + id +"?detailed="+detailed)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('items')
                });
        }

        function saveSsr(item){
            return $http.post(urlBase, item)
                .then(function(response){
                    messageService.register('items');
                    return response;
                })
                .catch(function(){
                    messageService.registerError('items')
                });
        }

        function updateSsr(itemId, item){
            return $http.put(urlBase + "/" + itemId, item)
                .then(function(response){
                    messageService.registerUpdate('ssr')
                    return response;
                })
                .catch(function(){
                    messageService.registerUpdateError('ssr')
                });
        }

        function deleteItem(itemId){
            return $http.delete(urlBase + "/" + itemId)
                .then(function(response){
                    messageService.registerDelete('items');
                    return response;
                })
                .catch(function(){
                    messageService.registerDeleteError('items');
                });
        }
    }
})();
